import React from 'react';
export const statFormContext = React.createContext(undefined);
export function useStatFormContext() {
    const context = React.use(statFormContext);
    return context !== null && context !== void 0 ? context : {};
}
